import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useMemo, useRef } from 'react';
import config from 'utils/config';
import { getAgentElement } from './mindsetAI';
import { sendMessageWhenIdle } from './sendMessageWhenIdle';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { CONTACT_FORM_SUBMITTED_EVENT } from 'screens/ContactFormModal';
export var defaultHelixMindsetContactFormModalToolDescription = "UI ACTION: Opens the in-app \"Contact us\" modal (contact form widget).\nUse this tool whenever the user's intent is to contact someone (support, admin, sales), to escalate/raise a ticket, to leave feedback, or to ask a question  \ne.g. \"speak to a real person\", \"talk to a human\", \"contact support\", \"raise a ticket\", \"complaint\", \"escalate\", \"talk to sales\", \"book a call\", \"leave feedback\".\nDefault behavior: If contact intent is present, open the modal first.\nDO NOT use when the user only wants instructions (e.g. \"Where is the contact form?\") or explicitly asks not to open anything.";
var description = config.helixMindsetContactFormModalToolDescription || defaultHelixMindsetContactFormModalToolDescription;
export var defaultContactFormModalNotSubmittedMsg = 'The user closed the contact form without leaving any feedback. Ask if they still need to get in touch with support or if there is anything else you can help with.';
var notSubmittedMsg = config.helixMindsetContactFormToolModalNotSubmitted || defaultContactFormModalNotSubmittedMsg;
export var defaultContactFormModalSubmittedMsg = 'The user submitted the contact form. Ask if there is anything else you can help with.';
var SubmittedMsg = config.helixMindsetContactFormToolModalSubmitted || defaultContactFormModalSubmittedMsg;
export function useMindsetContactFormModalTool(containerId) {
  var _useModalQueryParam = useModalQueryParam('contact-form'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    isModalOpen = _useModalQueryParam2[0],
    setHasContactFormModal = _useModalQueryParam2[1];
  var wasModalOpenRef = useRef(isModalOpen);
  var hasSubmittedRef = useRef(false);
  useEffect(function () {
    function handleSubmitted() {
      hasSubmittedRef.current = true;
    }
    window.addEventListener(CONTACT_FORM_SUBMITTED_EVENT, handleSubmitted);
    return function () {
      return window.removeEventListener(CONTACT_FORM_SUBMITTED_EVENT, handleSubmitted);
    };
  }, []);
  useEffect(function () {
    if (isModalOpen) {
      hasSubmittedRef.current = false;
    } else if (wasModalOpenRef.current) {
      if (!hasSubmittedRef.current) {
        sendMessageWhenIdle(getAgentElement(containerId), notSubmittedMsg);
      } else {
        sendMessageWhenIdle(getAgentElement(containerId), SubmittedMsg);
      }
    }
    wasModalOpenRef.current = isModalOpen;
  }, [isModalOpen, containerId]);
  var tool = useMemo(function () {
    return {
      name: 'open_contact_form_modal',
      description: description,
      runningDescription: 'Opening contact form',
      completedDescription: 'Opened contact form',
      parameters: {
        type: 'object',
        properties: {}
      },
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setHasContactFormModal(true);
                return _context.abrupt("return", {
                  success: true
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function handler() {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    };
  }, [setHasContactFormModal]);
  return {
    tool: tool
  };
}